import {Card, Col, DatePicker, Form, Input, InputNumber, Row, Switch, Select} from 'antd';
import RichEditor from '../../components/RichEditor';
import {useQuery} from 'react-query';

import api from '../../api';
import {onValuesChange} from '../../utils';
import { useState } from 'react';

const MeetingControlForm = ({form, onFinish, itemData}) => {

  console.log(itemData)

  var [statusId, setStatusId] = useState(null);

  const {data: {data: statusList = []} = {}} = useQuery(['statuses'],
    async () => {
      return await api.meetings.statusList();
    }, {
      cacheTime: Infinity,
    });
  const getStatusFormIndex = (list, statusId, fallbackIndex) => {
    const index = (list || []).findIndex((entry) => String(entry?.status) === String(statusId));
    return index >= 0 ? index : fallbackIndex;
  };

  return (
    <Form
      form={form}
      name="MeetingControlForm"
      labelCol={{span: 8}}
      wrapperCol={{span: 16}}
      layout="horizontal"
      onFinish={onFinish}
      onValuesChange={onValuesChange(form)}
    >
      <Form.Item label="Tagung" name="name" rules={[{required: true}]}><Input/></Form.Item>
      <Form.Item label="Bezeichnung in der Rechnung" rules={[{required: true}]}
                 name="full_name"><Input/></Form.Item>
      <Form.Item label="Kurzbezeichnung Namensschilder" rules={[{required: true}]}
                 name="short_name"><Input/></Form.Item>

      <Form.Item label="Kosten">
      <Form.List name="set_statuses">
        {fields => (<div>
          {statusList.map((item, index) => {
              const statusFormIndex = getStatusFormIndex(itemData.statuses, item.id, index);
              return <Card
                key={item.id}
                size="small"
                title={item.name}
                style={{marginBottom: 12}}
                bodyStyle={{paddingBottom: 0}}
              >
                <Form.Item key={`status_${item.id}`} hidden initialValue={item.id}
                           name={[statusFormIndex, 'status']}><Input/></Form.Item>
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Form.Item label="Preis" key={`price_${item.id}`} initialValue={0} rules={[{required: true}]}
                               name={[statusFormIndex, 'price']}>
                      <InputNumber addonAfter="€" style={{width: '100%'}}/>
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={8}>
                    <Form.Item label="Öffentlich" key={`public_registration_${item.id}`} valuePropName="checked"
                               initialValue={false} name={[statusFormIndex, 'public_registration']}>
                      <Switch/>
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={8}>
                    <Form.Item label="Sortierung" key={`public_registration_order_${item.id}`}
                               name={[statusFormIndex, 'public_registration_order']} initialValue={0}>
                      <InputNumber style={{width: '100%'}}/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Öffentlicher Name" key={`public_registration_label_${item.id}`}
                               name={[statusFormIndex, 'public_registration_label']}>
                      <Input/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Hinweis" key={`public_registration_note_${item.id}`}
                               name={[statusFormIndex, 'public_registration_note']}>
                      <Input/>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            }
          )}
        </div>)}
      </Form.List>
      </Form.Item>

      <Form.Item label="Anmeldeschluss" name="registration_latest_date" rules={[{required: true}]}>
        <DatePicker format="DD.MM.YYYY"/></Form.Item>
      <Form.Item label="Begleitperson" valuePropName="checked" name="companion"
                 initialValue={false}>
        <Switch/>
      </Form.Item>

      <p>Bei mehreren Tagungsorten/Terminen diese Felder leer lassen und dafür
        Tagungsorte über Liste hinzufügen.</p>

      <Form.Item label="Datum von" style={{marginBottom: 0}}>
        <Form.Item name="date_from" style={{display: 'inline-block'}}>
          <DatePicker format="DD.MM.YYYY"/>
        </Form.Item>
        <span className="inline-form-label">bis</span>
        <Form.Item style={{display: 'inline-block'}} name="date_to">
          <DatePicker format="DD.MM.YYYY"/>
        </Form.Item>
      </Form.Item>

      <Form.Item label="Zeit:" style={{marginBottom: 0}}>
        <Form.Item name="time" style={{display: 'inline-block', width: 'calc(50%)'}}>
          <Input/>
        </Form.Item>
      </Form.Item>

      <Form.Item label="Räumlichkeiten" name="place"><Input/></Form.Item>

      <Form.Item label="Straße" style={{marginBottom: 0}}>
        <Form.Item name="street" style={{display: 'inline-block'}}>
          <Input/>
        </Form.Item>
        <span style={{
          display: 'inline-block',
          width: '70px',
          lineHeight: '32px',
          textAlign: 'center'
        }}>PLZ/Ort:</span>
        <Form.Item style={{display: 'inline-block', width: 85}} name="post_index">
          <Input/>
        </Form.Item>
        <Form.Item style={{display: 'inline-block'}} name="area">
          <Input/>
        </Form.Item>
      </Form.Item>

      <Form.Item label="pdf-Dateiname" name="confirmation_pdf_filename"><Input/></Form.Item>
      <Row>
        <Col span={12}>
          <Form.Item label="Warteliste aktiv" valuePropName="checked" name="waitlist_enabled"
                     initialValue={false}>
            <Switch/>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Max. reguläre Teilnehmer" name="max_regular_participants">
            <InputNumber min={1} style={{width: '100%'}}/>
          </Form.Item>
        </Col>
      </Row>
      
      <Form.Item label="Ist aktiv" valuePropName="checked" name="is_visible"
                 initialValue={true}>
        <Switch/>
      </Form.Item>

      <Form.Item label="Status Beschreibung">
      <Select onChange={(value) => {
        setStatusId(value);
      }}>
          {statusList.map((item, index) => {
              return <Select.Option value={item.id}>{item.name}</Select.Option>  
            }
          )}
      </Select>
      </Form.Item>
      <Form.List name="set_desc_statuses">
        {fields => (<div>
          {statusList.map((item, index) => {
              const statusFormIndex = getStatusFormIndex(itemData.desc_statuses, item.id, index);
              const descStatus = (itemData.desc_statuses || [])[statusFormIndex] || {};
              return statusId === item.id && <div key={index}>
                <Form.Item key={`status_${item.id}`} hidden initialValue={item.id}
                           name={[statusFormIndex, 'status']}><Input/></Form.Item>
                <Form.Item key={`special_program_description_${item.id}`} label="Fachprogramm Titel"
                      name={[statusFormIndex, 'special_program_description']} rules={[{required: false}]}>
                <RichEditor type='' height={300} initialValue={descStatus.special_program_description}/>
                </Form.Item>
                <Form.Item key={`accompany_program_description_${item.id}`} label="Begleitprogramm Titel"
                      name={[statusFormIndex, 'accompany_program_description']} rules={[{required: false}]}>
                <RichEditor type='' height={300} initialValue={descStatus.accompany_program_description}/>
                </Form.Item>
                <Form.Item key={`evening_program_description_${item.id}`} label="Abendprogramm Titel"
                      name={[statusFormIndex, 'evening_program_description']} rules={[{required: false}]}>
                <RichEditor type='' height={300} initialValue={descStatus.evening_program_description}/>
                </Form.Item>
                <Form.Item key={`parking_pass_description_${item.id}`} label="Parkausweis Titel"
                      name={[statusFormIndex, 'parking_pass_description']} rules={[{required: false}]}>
                <RichEditor type='' height={300} initialValue={descStatus.parking_pass_description}/>
                </Form.Item>
              </div>
              }
          )}
        </div>)}
      </Form.List>
      <Form.Item label="Rechnungsnummer"
                 name="invoice_num"><Input/></Form.Item>
      {itemData.id && <>
        <hr className="hr"/>
        <h3>URL:</h3>
        <p>
          Anmeldung:<br/>
          <a href={`${process.env.REACT_APP_SITE_URL}/registration/${itemData.id}/`} target="_blank" rel="noreferrer">
            {`${process.env.REACT_APP_SITE_URL}/registration/${itemData.id}/`}
          </a>
        </p>
        <p>
          Direkte Statuslinks:<br/>
          {(itemData.statuses || []).map((item, index) => {
            const url = `${process.env.REACT_APP_SITE_URL}/registration/${itemData.id}/${item.status}/`
            return <><a href={url} key={index} target="_blank" rel="noreferrer">{item.name}: ({url})</a><br/></>
          })}
        </p>
      </>}
    </Form>
  );
};

export default MeetingControlForm;
